import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'gravatar',
    templateUrl: './GravatarView.html'
})
export class GravatarComponent implements OnInit {
    public static $name: string = 'gravatar';

    public baseUrl: string = 'https://www.gravatar.com/avatar/';

    @Input() public hash: string;
    @Input() public size: string;

    public ngOnInit() {
        if (!this.size) {
            this.size = '24';
        }
    }
}
